import { z } from 'zod';
// Mirrors the `pix_key_type` Postgres enum.
export const PixKeyTypeSchema = z.enum(['cpf', 'cnpj', 'email', 'phone', 'evp']);
//# sourceMappingURL=pix-key-type.dto.js.map